import axios from 'axios';

export const HTTP = axios.create({
  headers: {
    'X-OPERATION': 'PRESTACIONES-CLIENT',
    'content-type': 'application/json'
  }
})

export const UTILS = { 
    downloadDocument: function(response) {
                var link=document.createElement('a');

                var fileName = response.headers['x-file-name'];
                var contentType = response.headers['content-type'];
                var blob = new Blob([response.data], {type: contentType});


                //Soporte IE
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                   window.navigator.msSaveOrOpenBlob(blob, fileName);
                   return;
                 }

                var url= window.URL.createObjectURL(blob);
                link.href= url;
                link.download=fileName;
                document.body.appendChild(link);
                link.click();

                setTimeout(function(){
                       document.body.removeChild(link);
                       window.URL.revokeObjectURL(url);
                   }, 1000);
      }
    
} 

export const SOLICITUD = {
  checkVersionHeader: function (response) {
    var version = response.headers['x-service-version'];
    if (!window.$store.state.solicitud.serviceVersion || window.$store.state.solicitud.serviceVersion != version) {
        window.$store.commit('solicitud/setServiceVersion',version);
        console.log("Service version:"+version);
    }
},
getPecataHeaders()
{
    var headers = {};

    if (window.$store.state.solicitud.modoGestionInterno===true)
        headers = {
            'X-WEB': window.$store.state.solicitud.tokenGestionInterno
        };
    else
        headers = {
            'X-SOLICITUD': window.$store.state.solicitud.tokenGestion
        };

    if (/MSIE|Trident/.test(window.navigator.userAgent))
    {
        headers['Pragma'] = 'no-cache';
        headers['Cache-Control'] = 'no-cache, no-store';
    }

    return { headers:headers};
},
genericGet(service,cbok, cberr)
{
    if (!window.$store.state.solicitud.solicitante ||
        (!window.$store.state.solicitud.tokenGestionInterno && !window.$store.state.solicitud.tokenGestion))
    {
        cberr("No se ha cargado ninguna solicitud");
        return;
    }

    HTTP
        .get(window.baseServiceUrl+service,
        this.getPecataHeaders())
        .then((response) => {
            this.checkVersionHeader(response);
            cbok(response.data);
        }).catch(function (error) {
            cberr(error);
        });
},
genericPut (service,data,cbok, cberr)
{
    if (!window.$store.state.solicitud.solicitante ||
        (!window.$store.state.solicitud.tokenGestionInterno && !window.$store.state.solicitud.tokenGestion))
    {
        cberr("No se ha cargado ninguna solicitud");
        return;
    }

    HTTP
        .put(window.baseServiceUrl+service,
        data,this.getPecataHeaders())
        .then((response) => {
            
            cbok(response.data);
        }).catch(function (error) {
            cberr(error);
        });
},
genericPost(service,data,cbok, cberr)
{
    if (!window.$store.state.solicitud.solicitante ||
        (!window.$store.state.solicitud.tokenGestionInterno && !window.$store.state.solicitud.tokenGestion))
    {
        cberr("No se ha cargado ninguna solicitud");
        return;
    }

    HTTP
        .post(window.baseServiceUrl+service,
        data,this.getPecataHeaders())
        .then((response) => {

            cbok(response.data);
        }).catch(function (error) {
            cberr(error);
        });
},
genericDelete(service,cbok, cberr)
{
    if (!window.$store.state.solicitud.solicitante ||
        (!window.$store.state.solicitud.tokenGestionInterno && !window.$store.state.solicitud.tokenGestion))
    {
        cberr("No se ha cargado ninguna solicitud");
        return;
    }

    HTTP
        .delete(window.baseServiceUrl+service,
        this.getPecataHeaders())
        .then((response) => {
            cbok(response.data);
        }).catch(function (error) {
            cberr(error);
        });
},
}